export type FunnelStageCounts = {
  signup: number;
  activation: number;
  engagement: number;
  checkout_started: number;
  paid: number;
};

export type FunnelCohort = FunnelStageCounts & {
  week: string;
};

export type FunnelUtmRow = FunnelStageCounts & {
  source: string;
};

export type FunnelResponse = {
  overall: FunnelStageCounts;
  cohorts: FunnelCohort[];
  utm_sources: FunnelUtmRow[];
  engagement_min_searches: number;
  paid_source: { available: boolean };
  total_users: number;
  skipped_users_without_date: number;
};

export const FUNNEL_STAGES: { key: keyof FunnelStageCounts; label: string }[] = [
  { key: "signup", label: "Rejestracja" },
  { key: "activation", label: "Aktywacja (1. wyszukanie)" },
  { key: "engagement", label: "Engagement (≥3 wyszukania / filtr)" },
  { key: "checkout_started", label: "Checkout rozpoczęty" },
  { key: "paid", label: "Płatność" },
];
